<app-main-page>
  <div desktopTitle>
    {{ 'nav.live' | translate }}
  </div>
  <div class="flex">
    <ion-searchbar #filter
      mode="ios"
      [placeholder]="'general.filter' | translate"
      (ionInput)="onFilter(filter)"></ion-searchbar>
    <ion-button (click)="onFilters()">
      <ion-icon slot="icon-only"
        name="filter-outline"></ion-icon>
    </ion-button>
  </div>
  @if (mobileView()) {
    <swiper-container #swiper
      [scrollbar]="true"
      [modules]="swiperModules">
      <swiper-slide>
        @if (prospects$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, first: true, name: 'prospect', hasNew: true }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (didNotAnswer$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'didNotAnswer' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (callLater$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'callLater' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (contacted$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'contacted' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (booked$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'booked' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (meeting$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'meeting' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (pilotPlanned$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'pilotPlanned' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (piloting$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'piloting' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (offered$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'offered' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (contractSend$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'contractSend' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (done$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'done' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (archived$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'archived' }"></ng-container>
        }
      </swiper-slide>
      <swiper-slide>
        @if (notInterested$ | async; as items) {
          <ng-container [ngTemplateOutlet]="mobileList"
            [ngTemplateOutletContext]="{ items, name: 'notInterested', last: true }"></ng-container>
        }
      </swiper-slide>
    </swiper-container>
  } @else {
    <div class="flex">
      <div class="drop-zone"
        (drop)="drop($event, 'prospect')"
        (dragover)="allowDrop($event)">
        @if (prospects$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'prospect', hasNew: true }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'didNotAnswer')"
        (dragover)="allowDrop($event)">
        @if (didNotAnswer$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'didNotAnswer' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'callLater')"
        (dragover)="allowDrop($event)">
        @if (callLater$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'callLater' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'contacted')"
        (dragover)="allowDrop($event)">
        @if (contacted$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'contacted' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'booked')"
        (dragover)="allowDrop($event)">
        @if (booked$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'booked' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'meeting')"
        (dragover)="allowDrop($event)">
        @if (meeting$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'meeting' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'pilotPlanned')"
        (dragover)="allowDrop($event)">
        @if (pilotPlanned$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'pilotPlanned' }"></ng-container>
        }
      </div>
      <div class="drop-zone"
        (drop)="drop($event, 'piloting')"
        (dragover)="allowDrop($event)">
        @if (piloting$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'piloting' }"></ng-container>
        }
      </div>
      <div class="drop-zone">
        @if (offered$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'offered' }"></ng-container>
        }
      </div>
      <div class="drop-zone">
        @if (contractSend$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'contractSend' }"></ng-container>
        }
      </div>
      <div class="drop-zone">
        @if (done$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'done' }"></ng-container>
        }
      </div>
      <div class="drop-zone">
        @if (archived$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'archived' }"></ng-container>
        }
      </div>
      <div class="drop-zone">
        @if (notInterested$ | async; as items) {
          <ng-container [ngTemplateOutlet]="desktopList"
            [ngTemplateOutletContext]="{ items, name: 'notInterested' }"></ng-container>
        }
      </div>
    </div>
  }
</app-main-page>
<ng-template #desktopList
  let-items="items"
  let-name="name"
  let-hasNew="hasNew">
  <h5>{{ 'live.status.' + name | translate }}</h5>
  <div class="ion-margin-bottom">{{ 'live.contacts' | translate:{ num: items.length } }}</div>
  <div class="container">
    @if (hasNew) {
      <ion-item class="content new"
        button="true"
        lines="none"
        color="primary"
        (click)="onNewNote('prospect')">
        {{ 'item.add' | translate }}
      </ion-item>
      @if (roleS() === 'super-admin') {
        <ion-item class="content new"
          button="true"
          lines="none"
          color="primary"
          (click)="moveTo(items, 'draft')">
          {{ 'general.move' | translate }}
        </ion-item>
      }
    }
    @for (item of items; track item.guid) {
      <ion-item class="content"
        button="true"
        lines="none"
        [draggable]="true"
        (dragstart)="drag($event, item)"
        (click)="onItem(item)">
        <ng-container [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item }"></ng-container>
      </ion-item>
    }
  </div>
</ng-template>
<ng-template #mobileList
  let-items="items"
  let-first="first"
  let-last="last"
  let-name="name"
  let-hasNew="hasNew">
  <h5>
    @if (first) {
      <ion-button class="empty"
        fill="clear"></ion-button>
    } @else {
      <ion-button color="light"
        fill="clear"
        (click)="slidePrev()">
        <ion-icon slot="icon-only"
          name="chevron-back-outline"></ion-icon>
      </ion-button>
    }
    {{ 'live.status.' + name | translate }}
    @if (last) {
      <ion-button class="empty"
        fill="clear"></ion-button>
    } @else {
      <ion-button color="light"
        fill="clear"
        (click)="slideNext()">
        <ion-icon slot="icon-only"
          name="chevron-forward-outline"></ion-icon>
      </ion-button>
    }
  </h5>
  <div class="ion-margin-bottom">{{ 'live.contacts' | translate:{ num: items.length } }}</div>
  <div class="swiper-content">
    @if (hasNew) {
      <ion-item class="content new"
        button="true"
        lines="none"
        color="primary"
        (click)="onNewNote('prospect')">
        {{ 'item.add' | translate }}
      </ion-item>
    }
    @for (item of items; track item.guid) {
      <ion-item class="content"
        button="true"
        lines="none"
        [draggable]="true"
        (dragstart)="drag($event, item)"
        (click)="onItem(item)">
        <ng-container [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ item }"></ng-container>
      </ion-item>
    }
  </div>
</ng-template>
<ng-template #itemTemplate
  let-item="item">
  <div>
    {{ item.target }}<br />
    <ion-note>
      {{ item.date | timestamp:'d.M.yyyy' }}<br />
    </ion-note>
    <div class="info">
      @if (item.turnoverClass) {
        <br />{{ 'live.turnoverClass' | translate }}: {{ item.turnoverClass }}
      }
      @if (item.personnel >= 0) {
        <br />{{ 'live.personnel' | translate }}: {{ item.personnel }}
      }
    </div>
    @if (item.creator) {
      <ion-chip class="ion-margin-top">{{ item.creator.name }}</ion-chip>
    }
    @if (item.status === 'contacted' && item.contactType) {
      <br /><ion-chip>{{ 'partnerNote.contactTypes.' + item.contactType | translate }}</ion-chip>
    }
    @if (item.status === 'done') {
      <br /><ion-chip>
        <ion-icon name="calendar-outline"></ion-icon>
        @if (item.startDate) {
          {{ item.startDate | timestamp:'d.M.yyyy' }}
        }
      </ion-chip>
      <ion-chip>
        <ion-icon name="library-outline"></ion-icon>
        @if (item.trainingDate) {
          {{ item.trainingDate | timestamp:'d.M.yyyy' }}
        }
      </ion-chip>
    }
  </div>
</ng-template>